import { calendarDateKey } from './calendarTime';

// Rótulos de origem dos compromissos, iguais aos da tela da Agenda.
export const CALENDAR_SOURCE_LABELS = Object.freeze({
  manual: 'Manual',
  snooze: 'Conversa adiada',
  proposal: 'Proposta',
  google: 'Google Agenda',
  external: 'Sistema externo',
  contract: 'Contrato',
  ai: 'Agendado pela IA',
});

export const CONTRACT_EVENT_TYPE_LABELS = Object.freeze({
  delivery: 'Entrega',
  pickup: 'Retirada',
});

const contractBaseTitle = contract =>
  `${contract.recipient_name} · ${contract.template_name || 'Contrato'}`;

const contractItem = (contract, type, title, startsAt, endsAt) => ({
  id: `contract-${contract.id}-${type}`,
  title,
  starts_at: startsAt,
  ends_at: endsAt,
  source: 'contract',
  contact_id: contract.contact_id,
  contractData: contract,
  contractEventType: type === 'period' ? 'delivery' : type,
});

// Mesma montagem da Agenda: com entrega e retirada vira um período só; com uma das
// datas, um item de entrega ou de retirada.
export const buildContractCalendarEvents = contracts =>
  (contracts || []).flatMap(contract => {
    const baseTitle = contractBaseTitle(contract);

    if (contract.scheduled_at && contract.pickup_at) {
      return [
        contractItem(
          contract,
          'period',
          `Contrato: ${baseTitle}`,
          contract.scheduled_at,
          contract.pickup_at
        ),
      ];
    }

    return [
      contract.scheduled_at &&
        contractItem(
          contract,
          'delivery',
          `Entrega: ${baseTitle}`,
          contract.scheduled_at,
          contract.scheduled_at
        ),
      contract.pickup_at &&
        contractItem(
          contract,
          'pickup',
          `Retirada: ${baseTitle}`,
          contract.pickup_at,
          contract.pickup_at
        ),
    ].filter(Boolean);
  });

// Visão de um dia: entrega e retirada aparecem cada uma no seu dia civil (Brasília),
// mesmo quando o contrato tem as duas datas.
export const contractDayItems = (contracts, dayKey) =>
  (contracts || []).flatMap(contract => {
    const baseTitle = contractBaseTitle(contract);
    return [
      ['delivery', contract.scheduled_at, 'Entrega'],
      ['pickup', contract.pickup_at, 'Retirada'],
    ]
      .filter(([, at]) => at && calendarDateKey(at) === dayKey)
      .map(([type, at, prefix]) =>
        contractItem(contract, type, `${prefix}: ${baseTitle}`, at, at)
      );
  });

export const calendarSourceLabel = event => {
  if (event?.source === 'contract') {
    const type = CONTRACT_EVENT_TYPE_LABELS[event.contractEventType];
    return type
      ? `${CALENDAR_SOURCE_LABELS.contract} · ${type}`
      : CALENDAR_SOURCE_LABELS.contract;
  }
  if (event?.metadata?.studio_store_id) return 'Talkvia Studio';
  return CALENDAR_SOURCE_LABELS[event?.source] || event?.source || '';
};
